import type { Release } from '../releases.ts';

export default {
  version: '0.23.0',
  date: '2026-10-06',
  title: 'Log levels per service, and Operations in Monitor',
  summary: [
    'Set the log level per service in System status, without a restart',
    'The graphics renderer shows in System status like the other services',
    'Operations moved from Workflows to Monitor',
    'Fixed: removed storage locations no longer appear in Operations or the metrics',
  ],
  features: [
    'Administration → System status → Logs has a Logging card: pick the log level (trace, debug, info, warn, error, fatal) for the API, the workflow service, the graphics renderer, each media-worker role and each storage agent, and see the level the running services use. Changes apply within about 15 seconds without a restart, and Default goes back to the level the service started with (LOG_LEVEL). debug and trace are very verbose',
    'The graphics renderer now shows up in System status like the other services',
    'Operations moved from Workflows to Monitor (its own tab)',
  ],
  fixes: [
    'Removed storage locations no longer appear in Operations, in the metrics, or in the storage integrity check, and Operations uses the same agent disconnect time as the rest of PRISM',
  ],
} satisfies Release;
